import React from "react"

import { EventCard, Wrapper } from "components"

const FeaturedEvent = ({ event }) => (
  <Wrapper maxWidth={768 - 128}>
    <EventCard
      image={event.featuredPhoto}
      category={event.category}
      startDate={event.startDatetime}
      endDate={event.endDatetime}
      title={event.name}
      address={event.address}
      url={event.url}
    />
  </Wrapper>
)

export default FeaturedEvent
